export const BtnStyle = {
    color: "#424242",
    textDecoration: "none",
    position: "relative",
    backgroundColor: "transparent",
    padding: 0,
    minWidth: "auto",
    "&:after": {
        content: '""',
        position: "absolute",
        width: "100%",
        height: "1px",
        bottom: "0",
        left: "0",
        backgroundColor: "#424242",
        transform: "scaleX(0)",
        transformOrigin: "bottom right",
        transition: "transform 0.25s ease-out",
    },
    "&:hover:after": {
        transform: "scaleX(1)",
        transformOrigin: "bottom left",
    },
    "&:hover": {
        backgroundColor: "transparent",
    },
} 

export const BtnStyle1 = {
    color: "#424242",
    textDecoration: "none",
    position: "relative",
    backgroundColor: "transparent",
    padding: 0,
    minWidth: "auto",
    p : 0 ,
    m : 0 ,
    fontWeight: 100 ,
     fontSize : "12px" ,
      color : "black",
    "&:after": {
        content: '""',
        position: "absolute",
        width: "100%",
        height: "1px",
        bottom: "0",
        left: "0",
        backgroundColor: "#424242",
        transform: "scaleX(0)",
        transformOrigin: "bottom right",
        transition: "transform 0.25s ease-out",
    },
    "&:hover:after": {
        transform: "scaleX(1)",
        transformOrigin: "bottom left",
    },
    "&:hover": {
        backgroundColor: "transparent",
    },
} 